import { call, put } from 'redux-saga/effects';
import { checkMicrosoftLoginOnStartSaga } from '../auth/azureAuthSaga';
import { initAzureAuthSaga } from '../auth/initAzurAuthSaga';
import { attemptBridgeSsoSaga } from '../auth/bridgeSsoSaga';
import { logError } from '../../helpers/bugLogger';
import { bridgeSsoSettled } from '../../redux/login/actions';

/**
 * Saga that runs when the application starts
 * Handles initialization tasks like checking for previous Microsoft login
 */
export function* onAppInitSaga() {
    try {
        // Initialize Azure authentication
        yield call(initAzureAuthSaga);

        // Check if user was previously logged in with Microsoft
        yield call(checkMicrosoftLoginOnStartSaga);

        // Mobile-to-web bridge: attempt a silent login against the IDP SSO
        // session cookie. Must run after discovery (it needs the tenant's
        // OAuth2 method) and after the Microsoft restore (which may already
        // have signed the user in).
        yield call(attemptBridgeSsoSaga);
    } catch (error) {
        // Whatever threw, the steps after it did not run — including the SSO
        // bridge, which leaves its landing page on a loader until the watchdog
        // fires. A console line alone would make that look like the bridge's
        // fault.
        console.error('Error in onAppInitSaga:', error);
        logError(error instanceof Error ? error : new Error(String(error)));
        // The bridge saga is one of the steps that did not run, so nothing will
        // release the render hold it is waiting on. Releasing it here costs a
        // bridged arrival its silent login — which already failed — instead of
        // a blank page.
        yield put(bridgeSsoSettled());
    }
}
